import React, { Component, useState, useEffect, useContext } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SglContext from '../SglContext';
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";

import delete_image from "../images/trash.png";

class AddOrderSupplies extends React.Component {

    get sgl_webservice_iphone_order_supplies() {
        return this.context.sglApiUrl + '/iphonev2/ordersuppliesv2/';
    }

    get user_info_url() {
        return this.context.nestApiUrl + '/users/getLoggedInUser';
    }
      
    state = {
      current_show: localStorage.getItem('show_id'),

      governing_organization: '',
      company_name: '',
      logged_in_people_id: '',
      credit_hold:false,

      show_data:{},
      entries_list: [],
      pending_supplies: [],
      stall_check_in_info: {},
      stall_checkin_checkout_data: {
        "checkin_date": '',
        "checkin_time": '',
        "checkout_date": '',
        "checkout_time": ''
      },
      barn_types: [],
      pre_order_datetime: false,

      selected_entry:{
        entry_supplies : [],
        available_supplies : []
      },
      selected_entry_id:'-4',
      order_supply_to_add:'-1',
      amount: "",
      order_supply_error_msg: '',
      selected_showfees:[],
      entry_numbers:'',
      userData: {},

      pending_requests_list: [],

      order_delivery_information_required: false,
      order_delivery_display_phone: '', //used for display only
      order_delivery_barn_location: '',
      order_delivery_stall_location: '',
      order_delivery_arrival_date: '',
      order_delivery_arrival_time: '',
      order_delivery_trainer_name: '',

      order_supply_save_msg: '',
      switch_allowed: 0,
      switch_company_name: '',
      loading: true,
    }

    constructor() {
        super();
    //   this.onShowChange = this.onShowChange.bind(this);
      // bind function in constructor instead of render
    }


    componentDidUpdate(prevProps, prevState){
        if(prevProps.current_show !== this.props.current_show){
            var show_id = this.props.current_show;
            this.getSelectedShowOrderSupplies(show_id);
            this.setInitialState();
            this.setState({
                current_show: show_id,
            });
            
        }
        if (prevState.selected_showfees !== this.state.selected_showfees) {
            this.SetOrderDeliveryRequired();
          }
    }
    setInitialState(){
        this.setState({
            selected_entry:{
            entry_supplies : [],
            // pending_supplies : [],
            available_supplies : []
            },
            selected_entry_id:'-4',
            order_delivery_trainer_name:'',
            order_supply_to_add:'-1',
            amount: "",
            order_supply_error_msg: '',
            order_supply_save_msg: '',
            selected_showfees:[],
            order_delivery_information_required: false,
        });
        document.getElementById('step_1_warning').style.display = "none";
        document.getElementById('add_drop_fields').style.display = "block";
        document.getElementById('save_button_div').style.display = "block";
        document.getElementById('add_drop_success_message').style.display = "none";

    }

    resetChangeEntryState(){
        this.setState({
            order_supply_to_add:'-1',
            amount: "",
            order_supply_error_msg: '',
            selected_showfees:[],
            order_delivery_information_required: false,
            order_supply_save_msg: '',

        });
        document.getElementById('step_1_warning').style.display = "none";

    }
    componentDidMount() {
        var switches = this.context.switches.switches;
        // switch_name: "Order Supplies"
        var switch_found = switches.find(el => el.switch_name === "Order Supplies");
        var switch_allowed = 0;
        if(switch_found){
            switch_allowed = switch_found.value;
        }
        this.setState({
            switch_allowed: switch_allowed
        });
        if(switch_allowed){
            this.getAllData(localStorage.getItem('show_id'));
            document.title = "Add order supplies";

        } else {
            this.setState({
            switch_allowed: switch_allowed,
            switch_company_name: this.context.switches.company_name?this.context.switches.company_name:'The Company',
            loading:false
            })
        }
    }
    getQueryVariable(variable)
    {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
        }
        return(false);
    }
    renderArrivalDatePicker = () => {
        let dateToday = new Date();
        var dateShowEnd = new Date(this.state.show_data.show_end_date);
        return <DatePicker
            id="datepicker"
            name="txtArrivalDate"
            minDate={dateToday}
            maxDate= {dateShowEnd}
            renderCustomHeader={this.renderCustomHeader}
            dateFormat={"MM/dd/yyyy"}
            selected={this.state.order_delivery_arrival_date}
            onChange={this.handleArrivalDateChange}
        />
    }
    handleArrivalDateChange = (date, event) => {
        this.setState({
            order_delivery_arrival_date: date
        });
    };
    
    getAllData(show_id){
        this.getUserData();

        this.context.reportToGA('/sgl-wp-plugin/' + this.context.company_urlpath + '/'+show_id+'/ordersupplies');
        this.context.reportToFB('/sgl-wp-plugin/' + this.context.company_urlpath + '/'+show_id+'/ordersupplies');

        this.setState({loading:false});
        this.getSelectedShowOrderSupplies(show_id);
    }

    getSelectedShowOrderSupplies(show_id){
        axios.get(this.sgl_webservice_iphone_order_supplies+'GetEntriesSupplies',{
            params : {
                show_id : show_id,
                company_id: this.context.company_id,
                team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
            }
        }).then(results => {
            this.handleGetOderSuppliesData(results.data);
        })

    }

    handleGetOderSuppliesData(response){
        if(response.show_data.show_closed){
            this.setState({
                order_supply_save_msg: '',
                order_supply_error_msg: 'Show is closed. You cannot order supplies.'
            });
            document.getElementById('step_1_warning').style.display = "block";
            document.getElementById('add_class_fields').style.display = "none";
        } else if(!response.can_order_supplies){
            this.setState({
                order_supply_save_msg: '',
                order_supply_error_msg: 'You do not have permission to order supplies.'
            });
            document.getElementById('step_1_warning').style.display = "block";
            document.getElementById('add_class_fields').style.display = "none";
        } else {
            this.setState({
                order_supply_save_msg: '',
                order_supply_error_msg: ''
            });
            document.getElementById('step_1_warning').style.display = "none";
            document.getElementById('add_class_fields').style.display = "block";
        }

        var entry_id = this.getQueryVariable('entry_id');
        var entries_list = response.entries?response.entries:[];
        var selected_entry = {
            entry_supplies : [],
            // pending_supplies : [],
            available_supplies : []
        }
        var order_delivery_trainer_name = ''
        var selected_entry_id = '-4';
        if (entry_id && entry_id != ''){

            var entry = entries_list.find(el => el.entry_id === entry_id);
            if (entry){
                selected_entry_id = entry_id;
                selected_entry = entry;
                order_delivery_trainer_name = entry.entry_trainer
            }
        }
        this.setState({
            show_data: response.show_data,
            entries_list: response.entries?response.entries:[],
            pending_supplies: response.pending_supplies?response.pending_supplies:[],
            stall_check_in_info: response.stall_checkin_checkout_prefs?response.stall_checkin_checkout_prefs:{},
            credit_hold: response.show_data && response.show_data.credit_hold?response.show_data.credit_hold:false,
            selected_entry_id: selected_entry_id,
            selected_entry:selected_entry,
            order_delivery_trainer_name: order_delivery_trainer_name,
            barn_types: response.barn_types?response.barn_types:[],
            pre_order_datetime: response.pre_order_datetime,
        });

    }

    saveOrderSuppliesApiCall(show_id, entry_id, showfees_list, order_delivery, stall_checkin_checkout_data) {
        axios.get(this.sgl_webservice_iphone_order_supplies+'SaveOrderSupplies',{
            params : {
                show_id : show_id,
                entry_id: entry_id,
                showfees_list:showfees_list,
                order_delivery: order_delivery,
                company_id: this.context.company_id,
                sgl_plugin: true,
                team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
                ...((this.state.stall_check_in_info.stall_collect_checkin_checkout_time == '1' && this.checkIfStallOrdered()) ? { stall_checkin_checkout_data: stall_checkin_checkout_data } : {})

            }
        }).then(results => {
            this.setOrderSuppliesResponseData(results.data);
        })
    }


    saveOrderSupplies = () => (e) => {
        var selected_showfees_ids = this.state.selected_showfees.map((s)=>{
            return ({
            'showfees_id': s.showfees_id,
            'quantity': s.quantity
            })
        });

        let phone_number = '';
        if (this.state.order_delivery_information_required){
            phone_number = document.getElementById('phone_number');
            if(phone_number){
            phone_number = phone_number.value;
            }
        }

        if(selected_showfees_ids.length <= 0) {
            this.setState({
            order_supply_save_msg: 'There are no changes to save.'
            });
            
        }
        // else if (this.state.order_delivery_information_required && this.state.order_delivery_trainer_name == ''){
        //     this.setState({
        //     order_supply_save_msg: 'Please enter Trainer Name.'
        //     });
        // }
        else if (this.state.order_delivery_information_required && this.state.pre_order_datetime && this.state.order_delivery_arrival_date == ''){
            this.setState({
            order_supply_save_msg: 'Please select Arrival Date.'
            });
        }
        else if (this.state.order_delivery_information_required && this.state.pre_order_datetime && this.state.order_delivery_arrival_time == ''){
            this.setState({
            order_supply_save_msg: 'Please select Arrival Time.'
            });
        }
        //Validate invalid order delivery notification phone
        else if (this.state.order_delivery_information_required && (phone_number != '' || this.state.order_delivery_display_phone != '') && (phone_number.replace(/\D/g, "").length < 7)){
            this.setState({
            order_supply_save_msg: 'Please enter valid Delivery Notification Phone.'
            });
        }
        else if (this.state.order_delivery_information_required && !this.state.pre_order_datetime && this.state.order_delivery_barn_location.trim() == ''){ //do not require barn for pre order date time threshold
            this.setState({
            order_supply_save_msg: 'Please enter Barn Location.'
            });
        }
        else if (this.state.order_delivery_information_required && !this.state.pre_order_datetime && this.state.order_delivery_stall_location.trim() == ''){
            this.setState({
            order_supply_save_msg: 'Please enter Stall Location.'
            });
        }
        else if (this.getCheckinValidationMsg() != ''){
            this.setState({
            order_supply_save_msg: this.getCheckinValidationMsg()
            });
        }
        else { 
            let order_delivery = {};

            let formattedArrivalDate = ''
            if(this.state.order_delivery_arrival_date && this.state.order_delivery_arrival_date != ''){
                // format the date to avoid the timezone offset issues
                const date = new Date(this.state.order_delivery_arrival_date);
                const year = date.getFullYear();
                const month = ('0' + (date.getMonth() + 1)).slice(-2);
                const day = ('0' + date.getDate()).slice(-2);
                formattedArrivalDate = `${year}-${month}-${day}`;
            }

            if(this.state.order_delivery_information_required){
            order_delivery = {
                phone_number: phone_number.replace(/\D/g, ""),
                barn_location: this.state.order_delivery_barn_location,
                stall_location: this.state.order_delivery_stall_location,
                arrival_date: formattedArrivalDate,
                arrival_time: this.state.order_delivery_arrival_time,
                trainer_name: this.state.order_delivery_trainer_name,
            };
            }

            this.saveOrderSuppliesApiCall(this.state.current_show, this.state.selected_entry_id, JSON.stringify(selected_showfees_ids), JSON.stringify(order_delivery), JSON.stringify(this.state.stall_checkin_checkout_data));
        }
    }

    setOrderSuppliesResponseData(response_data){
        if(response_data.orders_saved) {
            // this.setState({
            //   pending_requests_list: response_data.pending_requests?response_data.pending_requests:[],
            // });
            document.getElementById('add_drop_fields').style.display = "none";
            document.getElementById('save_button_div').style.display = "none";
            
            document.getElementById('add_drop_success_message').style.display = "block";
            this.setState({
            pending_supplies: response_data.pending_supplies,
            selected_showfees: [],
            order_delivery_information_required: false,
            });
            
        } else {
            this.setState({
            order_supply_save_msg: response_data.errors
            });
        }
    }

    onEntrySelect(e){
      // this.resetChangeEntryState();
        if (e.target.value !== '-4'){
            const entry = this.state.entries_list.find(el => el.entry_id === e.target.value);

            this.setState({
            selected_entry_id: e.target.value,
            selected_entry: entry,
            order_delivery_trainer_name: entry?.entry_trainer?entry.entry_trainer:''
            // rider_select_disabled:false,
            });
            // this.getEntriesSuppliesList(this.state.current_show, e.target.value);
        } else {
            this.setState({
            selected_entry_id: e.target.value,
            order_delivery_trainer_name:'',
            selected_entry:{
                entry_supplies : [],
                // pending_supplies : [],
                available_supplies : []
            },
            // rider_select_disabled:true,
            });
        }
        if(!this.state.show_data.show_closed){
            document.getElementById('step_1_warning').style.display = "none";
        }
    }


    getUserData(){
        axios.get(this.user_info_url)
        .then((response) => {
            this.context.checkLoginOnSGL();
            if(response.data.user && response.data.user != null){
            this.setState({
                userData : response.data.user,
            });
            }else{
            }
        }, (error) => {
        });
    }
    onOrderSupplySelect(e){
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index]
        var web_default_qty = parseFloat(optionElement.getAttribute('web_default_qty'));
        
        this.setState({
            order_supply_to_add: e.target.value,
            amount: (web_default_qty > 0 && !isNaN(web_default_qty) ? web_default_qty : 1) 
        });
    }
    updateAmount(evt) {
        this.setState({
            amount: evt.target.value
        });
    }
    
    addOrderSupply = () => (e) => {
        
        if (this.state.selected_entry_id != '-4'){

            if (this.state.order_supply_to_add != '-1'){
            if (this.state.amount && this.state.amount != '' && this.state.amount >= 1){
                if (this.state.amount <= 999){

                document.getElementById('step_1_warning').style.display = "none";
                const show_fee = this.state.selected_entry.available_supplies.find(s => s.showfees_id === this.state.order_supply_to_add);
                var availabe_amount;
                if(show_fee.inventory_cap == 0 || show_fee.inventory_cap == '0'){
                    availabe_amount = 999;
                } else {
                    availabe_amount = show_fee.inventory_cap - show_fee.sold_to_date;
                }
                if (availabe_amount > 0){
                
                    if (this.state.amount > (availabe_amount)){
                    this.setState({
                        order_supply_error_msg: 'Order not placed as available quantity is ' + availabe_amount
                    });
                    document.getElementById('step_1_warning').style.display = "block";
                    } else {
                    show_fee.quantity = parseInt(this.state.amount);
                    
                    show_fee.total_price = parseInt(this.state.amount) * show_fee.unit_price;
                    const fees_already_added = this.state.selected_showfees.find(c => c.showfees_id === this.state.order_supply_to_add);
                    if (!fees_already_added){
                        this.setState(prevState => ({
                        selected_showfees: [...prevState.selected_showfees, show_fee],
                        // order_supply_to_add: '-1'
                        }))
                    }
                    }
                } else {
                    this.setState({
                    order_supply_error_msg: 'Item is out of stock. Please contact show office.'
                    });
                    document.getElementById('step_1_warning').style.display = "block";
                }
                // this.checkOrderSupplyToAdd(this.state.selected_show, this.state.order_supply_to_add, this.state.amount);
                } else {
                this.setState({
                    order_supply_error_msg: 'Amount must not be greater than 999.'
                });
                document.getElementById('step_1_warning').style.display = "block";
                }
                
            } else {
                this.setState({
                order_supply_error_msg: 'Amount must be a valid positive number.'
                });
                document.getElementById('step_1_warning').style.display = "block";
            }
            }
        } else {
            this.setState({
            order_supply_error_msg: 'Please select an Entry.'
            });
            document.getElementById('step_1_warning').style.display = "block";
        }
    }

    dropOrderSupply = (showfee_id) => {

        this.setState(prevState => ({
            order_supply_save_msg: '',
            selected_showfees: prevState.selected_showfees.filter(c => c.showfees_id !== showfee_id)
        }));
        // this.setCutOffMessage();
        var stalls = this.state.selected_showfees.filter(c => c.is_stall_fee && c.showfees_id !== showfee_id);
        if(stalls.length == 0){
            this.setState({
            stall_checkin_checkout_data: {
                "checkin_date": '',
                "checkin_time": '',
                "checkout_date": '',
                "checkout_time": ''
            }
            });
        }

    }

    getTotalFeePrice(){
        var previous_total = this.state.selected_entry.entry_supplies.reduce(function(prev, current) {
            return prev + +current.total_price
        }, 0);
        var selected_total = this.state.selected_showfees.reduce(function(prev, current) {
            return prev + +current.total_price
        }, 0);
        return previous_total + selected_total;
    }

    getCutOffMessage(){
        var cut_off_error_message = '';
        this.state.selected_showfees.forEach(show_fee => {
            if(cut_off_error_message == ''){
            cut_off_error_message = show_fee.cutoff_time_message;
            }
        });
        return cut_off_error_message

    }

    format_currancy(amount){
        if(amount == undefined || amount == ''){
            return '';
        }
        if(amount == 0){
            return '$0.00';
        }
        // return '$'+(amount && amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        return '$'+(amount && Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));

    }

    format_date(unformatted_date){
        var unformatted_date_split = (unformatted_date && unformatted_date.split)?unformatted_date.split('T')[0]:unformatted_date;
        var formatted_date = (new Date(unformatted_date_split));
        formatted_date = new Date(formatted_date.toISOString().slice(0, -1));
        return parseInt(formatted_date.getMonth()+1) +"/"+ formatted_date.getDate() +"/"+ formatted_date.getFullYear();
    }

    SetOrderDeliveryRequired(){
        let order_delivery_information_required = false;
        let order_delivery_display_phone = '';
        let order_delivery_barn_location = '';
        let order_delivery_stall_location = '';
        let order_delivery_arrival_date = '';
        let order_delivery_arrival_time = '';
        let order_delivery_trainer_name = '';

        //Check selected show fee require Order Delivery
        this.state.selected_showfees.forEach(show_fee => {
            if(show_fee.order_delivery_information_required){
            order_delivery_information_required = true;
            }
        });

        if(order_delivery_information_required){ //Order Delivery required for selected showfees
            order_delivery_display_phone = this.state.order_delivery_display_phone.trim();
            order_delivery_barn_location = this.state.order_delivery_barn_location.trim();
            order_delivery_stall_location = this.state.order_delivery_stall_location.trim();
            // order_delivery_arrival_date = this.state.order_delivery_arrival_date.trim();
            order_delivery_arrival_time = this.state.order_delivery_arrival_time.trim();
            order_delivery_trainer_name = this.state.order_delivery_trainer_name.trim();

            if(order_delivery_display_phone == ''){ //Not already set
            if(this.state.userData.phonenumber_verified){
                order_delivery_display_phone = '+' + this.state.userData.phonenumber.replace(/\D/g, "");
            }
            }
        }
        
        //Set Order delivery information in state
        this.setState({
            order_delivery_information_required: order_delivery_information_required,
            order_delivery_display_phone: order_delivery_display_phone,
            order_delivery_barn_location: order_delivery_barn_location,
            order_delivery_stall_location: order_delivery_stall_location,
            order_delivery_arrival_date: order_delivery_arrival_date,
            order_delivery_arrival_time: order_delivery_arrival_time,
            order_delivery_trainer_name: order_delivery_trainer_name,
            order_supply_save_msg: '',
        });
    }

    updateOrderDeliveryPhone(value){
        this.setState({
            order_delivery_display_phone: value
        });
    }
    handlePhoneChange = (status, phoneNumber, country) => {
        this.setState({ 'phoneNumber': phoneNumber, 'status':status });
        // var phone_number = '+' + phoneNumber.replace(/\D/g, "");
        if(status) {
            document.getElementById('phone_number').value = phoneNumber;
            document.querySelector("#valid_msg").classList.remove('hide');
        } else {
            document.querySelector("#valid_msg").classList.add('hide');
            document.getElementById('phone_number').value = '';
        }
        
        this.updateOrderDeliveryPhone(phoneNumber, -1);
    };
    
    updateOrderDeliveryBarnLocation(evt){
        this.setState({
            order_delivery_barn_location: evt.target.value
        });
    }

    updateOrderDeliveryStallLocation(evt){
        this.setState({
            order_delivery_stall_location: evt.target.value
        });
    }

    updateOrderDeliveryArrivalTime(evt){
        this.setState({
            order_delivery_arrival_time: evt.target.value
        });
    }

    updateOrderDeliveryTrainerName(evt){
        this.setState({
            order_delivery_trainer_name: evt.target.value
        });
    }

    // componentDidUpdate(prevProps, prevState) {
    //   if (prevState.selected_showfees !== this.state.selected_showfees) {
    //     this.SetOrderDeliveryRequired();
    //   }
    // }

    ///// stable reservation functions ////////////
    checkIfStallOrdered(){
        var ordered_stalls = this.state.selected_showfees.filter(c => c.is_stall_fee);
        if(ordered_stalls.length > 0){
            return true;
        }
        return false;
    }
    getCheckinDates(chechin_out){
        var start_date = new Date(this.state.show_data.show_start_date);
        start_date.setDate(start_date.getDate() - parseInt(this.state.stall_check_in_info.days_before_checkin));
        var end_date = new Date(this.state.show_data.show_end_date);
        if(chechin_out == 'out'){
            end_date.setDate(end_date.getDate() + parseInt(this.state.stall_check_in_info.days_after_checkout));
        }

        var dates_list = [];
        // loop for every day
        for (var day = start_date; day <= end_date; day.setDate(day.getDate() + 1)) {
                dates_list.push({
                display_date: parseInt(day.getMonth()+1) +"/"+ day.getDate() +"/"+ day.getFullYear(),
                date_value: day.getFullYear() +"-"+ parseInt(day.getMonth()+1) +"-"+ day.getDate()
                })
        }
        return dates_list;
    }
    getCheckinOutTime(chechin_out){
        var start_time,end_time,selected_date,first_date, last_date;
        if(chechin_out == 'in'){
            selected_date = this.state.stall_checkin_checkout_data.checkin_date;
            if(!selected_date || selected_date == ''){
            return []
            }
            first_date = this.getCheckinDates(chechin_out)[0].date_value;
            if(selected_date == first_date){
            start_time = parseInt(this.state.stall_check_in_info.first_day_checkin_start_time);
            end_time = parseInt(this.state.stall_check_in_info.first_day_checkin_end_time);
            } else {
            start_time = parseInt(this.state.stall_check_in_info.checkin_start_time);
            end_time = parseInt(this.state.stall_check_in_info.checkin_end_time);
            }

        } else {
            
            selected_date = this.state.stall_checkin_checkout_data.checkout_date;
            if(!selected_date || selected_date == ''){
            return []
            }
            last_date = this.getCheckinDates(chechin_out)[this.getCheckinDates(chechin_out).length-1].date_value;

            if(selected_date == last_date){
            start_time = parseInt(this.state.stall_check_in_info.last_day_checkout_start_time);
            end_time = parseInt(this.state.stall_check_in_info.last_day_checkout_end_time);
            } else {
            start_time = parseInt(this.state.stall_check_in_info.checkout_start_time);
            end_time = parseInt(this.state.stall_check_in_info.checkout_end_time);
            }
        }
        var time_list = [];
        
        // loop for every hour
        for (var hour = start_time; hour <= end_time; hour++) {
            var suffix = hour >= 12 ? "PM":"AM";
            var hours = ((hour + 11) % 12 + 1) +':00 '+ suffix;
            if(((hour + 11) % 12 + 1) < 10){
                hours = '0'+hours;
            }
                time_list.push({
                display_time: hours,
                time_value: hour
                });
        }
        return time_list;
    }
    getFormattedDisplayTime(chechin_out){
        var start_time,end_time,selected_date,first_date, last_date;
        if(chechin_out == 'in'){
            selected_date = this.state.stall_checkin_checkout_data.checkin_date;
            if(!selected_date || selected_date == ''){
            return 'Select check-in date'
            }
            first_date = this.getCheckinDates(chechin_out)[0].date_value;
            if(selected_date == first_date){
            start_time = parseInt(this.state.stall_check_in_info.first_day_checkin_start_time);
            end_time = parseInt(this.state.stall_check_in_info.first_day_checkin_end_time);
            } else {
            start_time = parseInt(this.state.stall_check_in_info.checkin_start_time);
            end_time = parseInt(this.state.stall_check_in_info.checkin_end_time);
            }

        } else {
            
            selected_date = this.state.stall_checkin_checkout_data.checkout_date;
            if(!selected_date || selected_date == ''){
            return 'Select check-out date'
            }

            last_date = this.getCheckinDates(chechin_out)[this.getCheckinDates(chechin_out).length-1].date_value;
            if(selected_date == last_date){
            start_time = parseInt(this.state.stall_check_in_info.last_day_checkout_start_time);
            end_time = parseInt(this.state.stall_check_in_info.last_day_checkout_end_time);
            } else {
            start_time = parseInt(this.state.stall_check_in_info.checkout_start_time);
            end_time = parseInt(this.state.stall_check_in_info.checkout_end_time);
            }
        }
        return this.getFormattedTime(start_time) + ' - ' + this.getFormattedTime(end_time);
    }

    getFormattedTime(hour){
        var suffix = parseInt(hour) >= 12 ? "PM":"AM";
        return ((parseInt(hour) + 11) % 12 + 1) +':00 '+ suffix
    }
    updateCheckinInfo(evt, field){
        var stall_checkin_checkout_data = this.state.stall_checkin_checkout_data;
        stall_checkin_checkout_data[field] = evt.target.value;
        if(field == 'checkin_date')
        {
            stall_checkin_checkout_data['checkin_time'] = '';
        }
        if(field == 'checkout_date')
        {
            stall_checkin_checkout_data['checkout_time'] = '';
        }
        this.setState({
            stall_checkin_checkout_data: stall_checkin_checkout_data
        })
    }
    getCheckinValidationMsg(){
        var error_msg = '';
        if(this.state.stall_check_in_info.stall_collect_checkin_checkout_time == '1' && this.checkIfStallOrdered()){
            if(this.state.stall_checkin_checkout_data.checkin_date == ''){
            error_msg = 'Please select check-in date'
            } else if(this.state.stall_checkin_checkout_data.checkin_time == ''){
            error_msg = 'Please select check-in time'
            } else if(this.state.stall_checkin_checkout_data.checkout_date == ''){
            error_msg = 'Please select check-out date'
            } else if(this.state.stall_checkin_checkout_data.checkout_time == ''){
            error_msg = 'Please select check-out time'
            } else if(new Date(this.state.stall_checkin_checkout_data.checkout_date).getTime() < new Date(this.state.stall_checkin_checkout_data.checkin_date).getTime()){
            error_msg = 'Check-out date cannot be before check-in date'
            } else if((new Date(this.state.stall_checkin_checkout_data.checkout_date).getTime() == new Date(this.state.stall_checkin_checkout_data.checkin_date).getTime()) && (parseInt(this.state.stall_checkin_checkout_data.checkout_time) < parseInt(this.state.stall_checkin_checkout_data.checkin_time))){
            error_msg = 'Check-out time cannot be before check-in time'
            }
        }
        return error_msg
    }
    ///// end stable reservation functions ////////////

    render(){
        const loading = this.state.loading;
        if(loading) {
            return null;
        }
        if(this.state.switch_allowed != 1){
            return(
                <div>
                <h2>Order Supplies</h2>
                <p>{this.state.switch_company_name + ' does not support this feature.'}</p>
                </div>
            )
        }
        return(
            <div className="sgl-plugin add-entry-page">
                {(this.state.credit_hold) ?
                <div id='checkout_redirect'>
                    <div id='credit_hold_warning'>
                        <p>Your account is currently on credit hold.  To continue please provide payment for your unpaid balances.</p>
                    </div>
                    <button className='sgl-button' >
                        <Link to='/checkout-entries' className="button-link">Pay Now</Link>
                    </button>
                            
                </div>
                :
                <div id='add_order_supplies'>
        
                    <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
                    <div id="ringWrapper" className='ringWrapper'>
                            
                        <div className="div-responsive">

                            {/* add order supplies  */}

                        
                            <div id="step_1_container" className='sgl-primary-header class-details primary-header class-details-header sgl-primary-header active_block'>
                                <p id="step_1_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name ">Order Supplies</p>
                                
                            </div>
                            <div id='step_4' className='add_entry_class add-entry-div'> 
                                <div id='add_drop_success_message' className='display_none'>
                                <span>Your request for Supplies has been submitted successfully. Thank you for using showgroundslive.com</span>
                                </div>
                                { (this.getCutOffMessage() != '') &&
                                <div id='cut_off_error_message' className='center-align'>
                                    <p className=' required'>{this.getCutOffMessage()}</p>
                                </div>
                                }
                                
                                <ul id='add_drop_fields'>
                                <li id="EntryRow" className='entry_people_li'>
                                    <label className="add_entry_label">Entry</label>
                                    <div style={{clear: "both"}}></div>
                                    <div className="people_selection_div">
                                            <select id="class_rider" className="input-height class_selection" value={this.state.selected_entry_id} onChange={(e) => this.onEntrySelect(e)}>
                                                <option value="-4">Select Entry...</option>
                                                {
                                                this.state.entries_list.map((entry,index) => {
                                                return (
                                                    <option value={`${entry.entry_id}`} key={entry.entry_id}>
                                                        {entry.entry_name}
                                                    </option>
                                                )
                                                })
                                                }
                                            </select>
                                    </div>
                                    <div style={{clear: "both"}}></div>
                                </li>
                                <div id='add_class_fields'>
                                <li id="OrderSuppliesRow" className='entry_people_li'>
                                    {/* <label class="required sgl-label-border"> Owner&nbsp;<em>*</em></label> */}
                                    {/* <hr className='hr_divider'/> */}
                                    <div style={{clear: "both"}}>
                                    <div className="txt-field-container-div">
                                        <label className='add_entry_label'>Order Supplies</label>
                                        <div style={{clear: "both"}}></div>
                                        <div className="txt-field-container">
                                            {/* <div class="input-box"> */}
                                                
                                                <select id="FeesList" className="input-height class_selection" value={this.state.order_supply_to_add} onChange={(e) => this.onOrderSupplySelect(e)}>
                                                    <option value="-1">Select an item to order... </option>
                                                    {
                                                    this.state.selected_entry.available_supplies.map((showfees,index) => {
                                                    return (
                                                        <option value={`${showfees.showfees_id}`} web_default_qty={`${showfees.web_default_qty}`} key={showfees.showfees_id}>
                                                            {showfees.supplies_name}
                                                        </option>
                                                    )
                                                    })
                                                    }

                                                </select>
                                            {/* </div> */}
                                        </div>
                                    </div>
                                    <div className="txt-field-container-div">
                                        <div>
                                            
                                                <label className='add_entry_label'>Amount</label>
                                                <div style={{clear: "both"}}></div>
                                                {/* <div className="input-box" style={{width: '400px'}} > */}
                                                <div className="txt-field-container">

                                                <input style={{width: "250px"}}
                                                    className="input-height input-text mr-15" type="text" name="txtAmount" id="" 
                                                    value={this.state.amount} 
                                                    onChange={evt => this.updateAmount(evt)}  
                                                />
                                                {/* <button  className="sgl-button search_button" type="button" title="Add" onClick={this.addOrderSupply()}>
                                                    Add
                                                </button> */}
                                                </div>
                                        </div>
                                    </div>
                                    <div className="txt-field-container-div">
                                        <label className='add_entry_label'> &nbsp;</label>
                                        <div style={{clear: "both"}}></div>
                                        <button className="sgl-button search_button" type="button" title="Add" onClick={this.addOrderSupply()}>
                                        Add
                                        </button>
                                    </div>
                                    </div>
                                </li>
                                </div>

                                {(this.state.stall_check_in_info.stall_collect_checkin_checkout_time == '1' && this.checkIfStallOrdered()) &&
                                    <div id='checkout_stall'>
                                    {/* <div style={{clear: "both"}}></div> */}
                                    <li className='entry_people_li'>
                                        <div style={{clear: "both"}}></div>
                                        <label className='sgl-label-border link_color mr-top-15'>Stable Reservation</label>                                  
                                    </li>
                                    <li className='entry_people_li'>
                                        <div style={{clear: "both"}}></div>
                                        <div className="txt-field-container-div checkin-field-container-div">
                                        <label className='add_entry_label'>Check-in Date</label>
                                        <div style={{clear: "both"}}></div>
                                        <div className="txt-field-container">
                                                <select id="checkinDate" className="input-height class_selection" 
                                                value={this.state.stall_checkin_checkout_data.checkin_date} 
                                                onChange={(e) => this.updateCheckinInfo(e, 'checkin_date')}
                                                >
                                                    <option value="">Select check-in date... </option>
                                                    {
                                                    this.getCheckinDates('in').map((date_range,index) => {
                                                    return (
                                                        <option value={date_range.date_value} key={date_range.date_value}>
                                                            {date_range.display_date}
                                                        </option>
                                                    )
                                                    })
                                                    }
                                                </select>
                                        </div>
                                        </div>
                                        <div className="txt-field-container-div checkin-field-container-div">
                                        <div>
                                                <label className='add_entry_label'>Check-in Time<span className='sponsor_text'> ({this.getFormattedDisplayTime('in')})</span></label>
                                                <div style={{clear: "both"}}></div>
                                                <div className="txt-field-container">
                                                <select id="checkinTime" className="input-height class_selection" 
                                                    value={this.state.stall_checkin_checkout_data.checkin_time} 
                                                    onChange={(e) => this.updateCheckinInfo(e, 'checkin_time')}
                                                >
                                                    <option value="">Select check-in time... </option>
                                                    {
                                                        this.getCheckinOutTime('in').map((time_range,index) => {
                                                        return (
                                                            <option value={time_range.time_value}>
                                                                {time_range.display_time}
                                                            </option>
                                                        )
                                                        })
                                                    }
                                                </select>
                                                </div>
                                        </div>
                                        </div> 
                                    </li>
                                    <li className='entry_people_li'>
                                        <div style={{clear: "both"}}></div>
                                        <div className="txt-field-container-div mr-top-10 checkin-field-container-div">
                                        <label className='add_entry_label'>Check-out Date</label>
                                        <div style={{clear: "both"}}></div>
                                        <div className="txt-field-container">
                                                
                                                <select id="checkoutDate" className="input-height class_selection" 
                                                value={this.state.stall_checkin_checkout_data.checkout_date} 
                                                onChange={(e) => this.updateCheckinInfo(e, 'checkout_date')}
                                                >
                                                    <option value="">Select check-out date... </option>
                                                    {
                                                    this.getCheckinDates('out').map((date_range,index) => {
                                                    return (
                                                        <option value={date_range.date_value}>
                                                            {date_range.display_date}
                                                        </option>
                                                    )
                                                    })
                                                    }
                                                </select>
                                        </div>
                                        </div>
                                        <div className="txt-field-container-div mr-top-10 checkin-field-container-div">
                                        <div>
                                                <label className='add_entry_label'>Check-out Time<span className='sponsor_text'> ({this.getFormattedDisplayTime('out')})</span></label>
                                                <div style={{clear: "both"}}></div>
                                                <div className="txt-field-container">
                                                <select id="checkoutTime" className="input-height class_selection" 
                                                value={this.state.stall_checkin_checkout_data.checkout_time} 
                                                onChange={(e) => this.updateCheckinInfo(e, 'checkout_time')}
                                                >
                                                    <option value="">Select check-out time... </option>
                                                    {
                                                        this.getCheckinOutTime('out').map((time_range,index) => {
                                                        return (
                                                            <option value={time_range.time_value}>
                                                                {time_range.display_time}
                                                            </option>
                                                        )
                                                        })
                                                    }
                                                </select>
                                                </div>
                                        </div>
                                        </div>
                                    </li>
                                    </div>
                                }
                                <li className='entry_people_li'>
                                    <div style={{clear: "both"}}></div>
                                    <div id='step_1_warning' className='new-line required display_none'>{this.state.order_supply_error_msg}</div>
                                </li>
                                

                                <li className='entry_people_li'>
                                        <table className="table table-striped table-hover">
                                        <thead className="classes-header">                    
                                            <tr className="sgl-primary-header">
                                            <th className="display_on_desktop">Qty</th>
                                            <th className="display_on_desktop">Description</th>
                                            <th className='right-align display_on_desktop'>Unit Price</th>
                                            <th className='right-align display_on_desktop'>Total</th>
                                            <th className='right-align display_on_desktop'>Tax Abbr.</th>
                                            <th className="display_on_mobile_th">Order Supplies</th>
                                            <th ></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        { 
                                            this.state.selected_entry.entry_supplies.map((data, index) => {
                                            return (
                                                <tr>
                                                <td className="display_on_mobile mbl_custom_row">
                                                    <p className="table_row_p">
                                                    <span><strong>Qty:</strong> {data.quantity}</span>
                                                    <br></br>
                                                    <span><strong>Description:</strong> {data.supplies_name}</span>
                                                    <br></br>
                                                    <span><strong>Total:</strong> {this.format_currancy(data.total_price)}</span>
                                                    <br></br>
                                                    <span><strong>Tax Abbr.:</strong> {data.tax_abbr}</span>
                                                    </p>
                                                </td>
                                                <td className="display_on_desktop">{parseInt(data.quantity)}</td>
                                                <td className="display_on_desktop">{data.supplies_name}</td>
                                                <td className='right-align display_on_desktop'>{this.format_currancy(data.unit_price)}</td>
                                                <td className='right-align display_on_desktop'>{this.format_currancy(data.total_price)}</td>
                                                <td className="right-align display_on_desktop">{data.tax_abbr}</td>
                                                <td >&nbsp;</td>
                                                {/* <td className='center-align mobile_trash_container'><img src={delete_image} className="placing-icon trash-icon" onClick={() => this.dropOrderSupply(data.showfees_id)}/></td> */}
                                                </tr>
                                            )
                                            })
                                        }
                                        
                                        { 
                                            this.state.selected_showfees.map((data, index) => {
                                            return (
                                                <tr>
                                                <td className="display_on_mobile mbl_custom_row">
                                                    <p className="table_row_p">
                                                    <span><strong>Qty:</strong> {data.quantity}</span>
                                                    <br></br>
                                                    <span><strong>Description:</strong> {data.supplies_name}</span>
                                                    <br></br>
                                                    <span><strong>Total:</strong> {this.format_currancy(data.total_price)}</span>
                                                    <br></br>
                                                    <span><strong>Tax Abbr.:</strong> {data.tax_abbr}</span>
                                                    </p>
                                                </td>
                                                <td className="display_on_desktop">{parseInt(data.quantity)}</td>
                                                <td className="display_on_desktop">{data.supplies_name}</td>
                                                <td className='right-align display_on_desktop'>{this.format_currancy(data.unit_price)}</td>
                                                <td className='right-align display_on_desktop'>{this.format_currancy(data.total_price)}</td>
                                                <td className="right-align display_on_desktop">{data.tax_abbr}</td>
                                                <td className='center-align mobile_trash_container'><img src={delete_image} className="placing-icon add-entry-trash-icon" onClick={() => this.dropOrderSupply(data.showfees_id)}/></td>
                                                </tr>
                                            )
                                            })
                                        }
                                        
                                        <tr>
                                            <td className="display_on_desktop">&nbsp;</td>
                                            <td className="right-align"><span className="display_on_mobile"><strong>Subtotal</strong></span></td>
                                            <td className='display_on_desktop right-align'><strong>Subtotal</strong></td>
                                            <td className='right-align'><strong>
                                            {this.format_currancy(this.getTotalFeePrice())}
                                            </strong>
                                            </td>
                                            <td  className="display_on_desktop">&nbsp;</td>
                                            <td  className="display_on_desktop">&nbsp;</td>
                                        </tr>
                                        </tbody>
                                        
                                    </table>
                                </li>

                                <li className='entry_people_li'>
                                    <p>Click <img src={delete_image} className="placing-icon add-entry-trash-icon" /> To Remove An Item</p>
                                </li>

                                { (this.state.selected_showfees.length > 0 && this.state.order_delivery_information_required) &&
                                <React.Fragment>
                                <li className='entry_people_li' style={{clear: "both"}}>
                                    <p className="add-entry-p">Please enter Order Delivery information for ordered supplies.</p>
                                </li>
                                <li className='entry_people_li' style={{clear: "both"}}>
                                    <div style={{clear: "both"}}>
                                    <div className="txt-field-container-div">
                                        <label className='add_entry_label sgl-add_entry' for="txtTrainerName">Trainer Name</label>
                                        <div style={{clear: "both"}}></div>
                                        <div className="input-box txt-field-container">
                                        <input type="text" name="txtTrainerName" id='txtTrainerName' disabled={true} className="input-height" value={this.state.order_delivery_trainer_name} onChange={evt => this.updateOrderDeliveryTrainerName(evt)} onBlur={evt => this.updateOrderDeliveryTrainerName(evt)}/>
                                        </div>
                                    </div>
                                    </div>
                                    <div style={{clear: "both"}}>
                                    <div className="txt-field-container-div">
                                        <label className='add_entry_label sgl-add_entry' for="txtArrivalDate">Arrival Date</label>
                                        <div style={{clear: "both"}}></div>
                                        <div className="input-box txt-field-container">
                                        {this.renderArrivalDatePicker()}
                                        </div>
                                    </div>
                                    <div className="txt-field-container-div">
                                        <label className='add_entry_label sgl-add_entry' for="txtArrivalTime">Arrival Time</label>
                                        <div style={{clear: "both"}}></div>
                                        <div className="input-box txt-field-container">
                                            <select id="ArrivalTime" className="input-height class_selection" value={this.state.order_delivery_arrival_time} onChange={(e) => this.updateOrderDeliveryArrivalTime(e)}>
                                                <option value="">Select Arrival Time</option>
                                                <option value="08:00:00">08:00 AM</option>
                                                <option value="09:00:00">09:00 AM</option>
                                                <option value="10:00:00">10:00 AM</option>
                                                <option value="11:00:00">11:00 AM</option>
                                                <option value="12:00:00">12:00 PM</option>
                                                <option value="13:00:00">01:00 PM</option>
                                                <option value="14:00:00">02:00 PM</option>
                                                <option value="15:00:00">03:00 PM</option>
                                                <option value="16:00:00">04:00 PM</option>
                                                <option value="17:00:00">05:00 PM</option>
                                                <option value="18:00:00">06:00 PM</option>
                                                <option value="19:00:00">07:00 PM</option>
                                                <option value="20:00:00">08:00 PM</option>
                                                <option value="21:00:00">09:00 PM</option>
                                                <option value="22:00:00">10:00 PM</option>
                                                <option value="23:00:00">11:00 PM</option>
                                                <option value="00:00:00">12:00 AM</option>
                                                <option value="01:00:00">01:00 AM</option>
                                                <option value="02:00:00">02:00 AM</option>
                                                <option value="03:00:00">03:00 AM</option>
                                                <option value="04:00:00">04:00 AM</option>
                                                <option value="05:00:00">05:00 AM</option>
                                                <option value="06:00:00">06:00 AM</option>
                                                <option value="07:00:00">07:00 AM</option>
                                            </select>
                                        </div>
                                    </div>
                                    </div>
                                    <div style={{clear: "both"}}>
                                    <div className="txt-field-container-div" style={{'width': '40%'}}>
                                        <label className='add_entry_label sgl-add_entry'>Delivery Notification Phone</label>
                                        <div style={{clear: "both"}}></div>
                                        <div className="txt-field-container">
                                        <div style={{display:'inline-block'}}>

                                            <IntlTelInput
                                                style={{
                                                width: "100%",
                                                }}
                                                formatOnDisplay={true}
                                                placeholder={"MOBILE"}
                                                initialCountry={"us"}
                                                // utilsScript={"https://showgroundslive.com/js/utils.js"}
                                                preferredCountries={["us", "ca"]}
                                                onPhoneNumberChange={this.handlePhoneChange}
                                                name={"phone_number_plugin_" + this.props.people_id}
                                                id={"phone_number_plugin_" + this.props.people_id} 
                                                value={this.state.order_delivery_display_phone}
                                                
                                            />
                                        </div>

                                        <input 
                                            type="hidden" 
                                            className="digital_signature_phonenumber" 
                                            id="phone_number" 
                                            name="phone_number" 
                                        />
                                        {/* <DigiSignPhone phonenumber={this.state.order_delivery_display_phone} onUpdate={this.updateOrderDeliveryPhone.bind(this)}/> */}
                                        <span id="valid_msg" className="hide">
                                            <img src={"https://showgroundslive.com/images/tick_icon.png"} style={{'padding-left':'5px', width:'20px', height:'16px'}} />
                                        </span>
                                        </div>
                                    </div>
                                    </div>
                                    <div style={{clear: "both"}}>
                                    <div className="txt-field-container-div">
                                        <label className='add_entry_label sgl-add_entry' for="txtBarnLocation">Barn Location</label>
                                        <div style={{clear: "both"}}></div>
                                        <div className=" txt-field-container">
                                        {(this.state.barn_types.length > 0) ?
                                        <select id="txtBarnLocation" className="input-height class_selection" value={this.state.order_delivery_barn_location} onChange={(e) => this.updateOrderDeliveryBarnLocation(e)}>
                                            <option value="">Select Barn Location</option>
                                            {
                                            this.state.barn_types.map((barn_type,index) => {
                                                return (
                                                    <option value={`${barn_type}`}>
                                                        {barn_type}
                                                    </option>
                                                )
                                            })
                                            }
                                        </select>
                                        :
                                        <input type="text" name="txtBarnLocation" id='txtBarnLocation' className="input-height" value={this.state.order_delivery_barn_location} onChange={evt => this.updateOrderDeliveryBarnLocation(evt)} onBlur={evt => this.updateOrderDeliveryBarnLocation(evt)}/>
                                        }
                                        </div>
                                    </div>
                                    <div className="txt-field-container-div">
                                        <label className='add_entry_label sgl-add_entry' for="txtStallLocation">Stall Location</label>
                                        <div style={{clear: "both"}}></div>
                                        <div className="input-box txt-field-container">
                                        <input type="text" name="txtStallLocation" id='txtStallLocation' className="input-height" value={this.state.order_delivery_stall_location} onChange={evt => this.updateOrderDeliveryStallLocation(evt)} onBlur={evt => this.updateOrderDeliveryStallLocation(evt)}/>
                                        </div>
                                    </div>
                                    </div>
                                </li>
                                </React.Fragment>      
                                }
                                { (this.state.selected_showfees.length > 0) &&
                                <li className='entry_people_li'>
                                    <div style={{clear: "both"}}></div>
                                    <div id='step_1_warning' className='new-line required display_none'>{this.state.order_supply_error_msg}</div>
                                </li>
                                }

                                { (this.state.selected_showfees.length > 0 || this.state.order_supply_save_msg != '') &&
                                    <li className='entry_people_li' style={{clear: "both"}}>
                                    { (this.state.order_supply_save_msg != "") ?
                                        <p className='required'>{this.state.order_supply_save_msg}</p>
                                    :
                                        <p className='required'>Once you are done with the changes, please click Save button to make the changes permanent.</p>
                                    } 
                                    </li>
                                    
                                }
                                </ul>
                                {/* <hr/> */}
                                <div id='save_button_div' className='continue-button-div'>
                                <div className='required float_right'>
                                    * Required Fields
                                </div>
                                <br className="sgl-mb-5"/>
                                <button className='sgl-button float_right' onClick={this.saveOrderSupplies()}>
                                    Save
                                </button>
                                </div>
                            </div>
                            
                            {/* add order supplies - Pending requests */}

                            <div id="step_2_container" className='sgl-primary-header class-details, primary-header class-details-header add_entry_options'>
                                <p id="step_2_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Pending Requests</p>
                            </div>
                            <div id='step_2' className='add_entry_class add-entry-div'> 
                                
                                
                                <ul>
                                <li className='entry_people_li'>
                                    { (this.state.pending_supplies.length > 0) &&
                                    <div className="table-scroll">
                                    <table className="table">
                                        <thead className="classes-header">                    
                                        <tr className="sgl-primary-header">
                                            <th className="display_on_mobile_th"></th>
                                            <th className="display_on_desktop">Entry Number</th>
                                            <th className="display_on_desktop">Qty</th>
                                            <th className="display_on_desktop">Description</th>
                                            <th className='right-align display_on_desktop'>Unit Price</th>
                                            <th className='right-align display_on_desktop'>Total</th>
                                            <th className='right-align display_on_desktop'>Tax Abbr.</th>
                                            {/* <th >&nbsp;</th> */}
                                        </tr>
                                        </thead>
                                        <tbody>
                                        { 
                                            // this.state.entries_list.map((entry, index) => {
                                            //   return (
                                                this.state.pending_supplies.map((data, index) => {
                                                return (
                                                    <tr>
                                                        <td className="display_on_mobile mbl_custom_row">
                                                            <p className="table_row_p">
                                                            <span><strong>Entry Number:</strong> {data.entry_number}</span>
                                                            <br></br>
                                                            <span><strong>Qty:</strong> {data.quantity}</span>
                                                            <br></br>
                                                            <span><strong>Description:</strong> {data.supplies_name}</span>
                                                            <br></br>
                                                            <span><strong>Total:</strong> {this.format_currancy(data.total_price)}</span>
                                                            <br></br>
                                                            <span><strong>Tax Abbr.:</strong> {data.tax_abbr}</span>
                                                            </p>
                                                        </td>
                                                        <td className="display_on_desktop">{data.entry_number}</td>
                                                        <td className="display_on_desktop">{parseInt(data.quantity)}</td>
                                                        <td className="display_on_desktop">{data.supplies_name}</td>
                                                        <td className='right-align display_on_desktop'>{this.format_currancy(data.unit_price)}</td>
                                                        <td className='right-align display_on_desktop'>{this.format_currancy(data.total_price)}</td>
                                                        <td className="right-align display_on_desktop">{data.tax_abbr}</td>
                                                    </tr>
                                                )
                                                })
                                            //   )

                                            // })
                                        }
                                        </tbody>
                                    </table>
                                    </div>
                                    }

                                </li>
                                
                                </ul>
                                
                            </div>

                        
                        </div>
                    </div>
                </div>
                }
                <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
            </div>
        )
    }
  }
  AddOrderSupplies.contextType = SglContext;

export default AddOrderSupplies;